import React from 'react';
import { Link } from 'react-router-dom';
import { LEADERBOARD_COLUMNS, SLOTS } from '../../metadata/fields.js'

function LeaderboardTableRow({ rank, clan, selectedPeriod, selectedColumn, highlightRow, onClick }) {
    //get the slot of the selected field so we can put the right color
    const colorClass = (column) => {
        let slot = Object.keys(LEADERBOARD_COLUMNS).filter((item) => LEADERBOARD_COLUMNS[item].filterable).indexOf(column);
        return SLOTS[slot % SLOTS.length];
    }
    const clanField = Object.keys(LEADERBOARD_COLUMNS).map((column, index) => {
        return(
            <>
            {LEADERBOARD_COLUMNS[column].filterable && clan.period === selectedPeriod ? (
                    <td key={index} className={colorClass(column) + ' ' + (column === selectedColumn ? 'highlight ' : '') }>{ LEADERBOARD_COLUMNS[column].formatter ? LEADERBOARD_COLUMNS[column].formatter(clan[column]) : clan[column] }</td>
                ) : (
                    null
                )
            }
            </>
        )
    });

    const clanNameField = (
        <td className="sticky clanName">
            <Link to={`/${window.LOCALE}/clanleaderboard/clan/${clan['clan_db_id']}`}><span className={"name " + (highlightRow ? 'highlight' : '')}>{clan['name'] ?? 'Missing Clan Name'}</span> <span className="orange-text tag">[{clan['tag'] ?? '?'}]</span></Link>
        </td>
    )

    const rankField = (
        <td className="sticky rank">
            {rank ? "#" + rank : ''}
        </td>
    )

    return(
        <tr key={clan.clan_db_id} className={highlightRow ? 'highlight' : ''} onClick={onClick}>
            { rankField }
            { clanNameField }
            { clanField }
        </tr>
    )
}

export default LeaderboardTableRow;
